import { useEffect, useState } from "react";
import {
  Button,
  Group,
  Container,
  ScrollArea,
  Card,
  Text,
  CardSection,
  Box,
  Grid,
  Modal,
  Space,
  Divider,
  MediaQuery,
  TextInput,
  Checkbox,
  Textarea,
  Chips,
  Chip,
  NativeSelect,
  LoadingOverlay,
  useMantineTheme,
  Tooltip,
  Badge,
} from "@mantine/core";

import { Pencil2Icon, TrashIcon, StarIcon ,PlusIcon  } from "@modulz/radix-icons";
import PropTypes from "prop-types";
import { useModals } from "@mantine/modals";
import { useForm } from "@mantine/form";
import Toast from "./../Toast";
import moment from "moment";
import {
  fetchAnnouncementsApi,
  deleteAnnouncementApi,
  editAnnouncementApi,
  newAnnouncementApi,
  newAllDomainsAnnouncementApi,
} from "./../../api/dashboard";
import { fetchDomainsApi } from "./../../api/general";
import { useMediaQuery } from "@mantine/hooks";

async function newAnnouncement(values) {
  const res = await newAnnouncementApi(values).catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired" || err.response.data.message== "Token expired"){
        localStorage.clear();
        window.location.replace("/");}
    }
  });
  if (res != null) {
    if (res.status == 200) {
      Toast("Success", res.data.message, "green");
      return res.data.newAnnouncement;
    } else {
      Toast("ERROR", res.data.message, "red");
      return;
    }
  } else return;
}

async function newAllDomainsAnnouncement(values) {
  const res = await newAllDomainsAnnouncementApi(values).catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired" || err.response.data.message== "Token expired"){
        localStorage.clear();
        window.location.replace("/");}
    }
  });
  if (res != null) {
    if (res.status == 200) {
      Toast(
        "Success",
        res.data.message != null
          ? res.data.message
          : "Announcements Added Successfully ....",
        "green"
      );
      return res.data.announcements;
    } else {
      Toast("ERROR", res.data.message, "red");
      return;
    }
  } else return;
}

async function deleteAnnouncement(values) {
  const res = await deleteAnnouncementApi(values).catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired" || err.response.data.message== "Token expired"){
        localStorage.clear();
        window.location.replace("/");}
    }
  });
  if (res != null) {
    if (res.status == 200) {
      Toast("Sucessfully Deleted", res.data.message, "green");
      return true;
    } else {
      Toast("ERROR", res.data.message, "red");
      return false;
    }
  } else return false;
}

async function fetchAnnouncements() {
  const res = await fetchAnnouncementsApi().catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired"){
        localStorage.clear();
        window.location.replace("/");}
    }
  });
  if (res != null) {
    if (res.status == 200) {
      return res.data;
    } else {
      Toast("ERROR", res.data.message, "red");
      return [];
    }
  } else return [];
}

async function editAnnouncement(values) {
  var obj = {};
  for (var index in values.fields) {
    obj["id"] = values.id;
    obj[String(values.fields[index])] = values[String(values.fields[index])];
  }
  if (obj.id == null) {
    Toast("Choose atleast one edit field", "", "red");
    return;
  }
  const res = await editAnnouncementApi(obj).catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired" || err.response.data.message== "Token expired"){
        localStorage.clear();
        window.location.replace("/");}
    }
  });
  if (res != null) {
    if (res.status == 200) {
      Toast("Success", res.data.message, "green");
      return res.data.editedAnnouncement;
    } else {
      Toast("ERROR", res.data.message, "red");
      return;
    }
  } else return;
}

async function fetchDomains() {
  const res = await fetchDomainsApi().catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired"){
        localStorage.clear();
        window.location.replace("/");}
    }
  });
  if (res != null) {
    if (res.status == 200) {
      return res.data.domains;
    } else {
      Toast("ERROR", res.data.message, "red");
      return [];
    }
  } else {
    return [];
  }
}

function Announcement({ announcement }) {
  const [opened, setOpened] = useState(false);
  const [deleted, setdeleted] = useState(false);
  const [priority, setpriority] = useState(announcement.important);
  const [title, settitle] = useState(announcement.title);
  const [message, setmessage] = useState(announcement.message);
  const [domain] = useState(announcement.DomainName);
  const [isLoad, setLoad] = useState(false);
  var theme = useMantineTheme();
  const isScreenLarge = useMediaQuery("(min-width: 500px)", false);
  const form = useForm({
    initialValues: {
      id: announcement.id,
      title: "",
      message: "",
      important: false,
      fields: [],
    },
  });
  const deleteModals = useModals();
  const openDeleteModal = () => {
    const id = deleteModals.openModal({
      title: "Delete Anouncement: " + title,
      children: (
        <>
          <Button
            fullWidth
            onClick={() => {
              setLoad(true);
              deleteAnnouncement({ id: announcement.id }).then((deleteBool) => {
                setLoad(false);
                if (deleteBool == true) {
                  setdeleted(true);
                }
              });
              deleteModals.closeModal(id);
            }}
            mt="md"
            style={{ backgroundColor: "red" }}
          >
            Confirm Delete
          </Button>
        </>
      ),
    });
  };
  if (deleted) {
    return (
      <CardSection key={String(announcement.id)} style={{ marginBottom: 10 }}>
        <Card shadow="md">
          <Text
            style={{
              fontSize: "25px",
              color: "red",
              textAlign: "left",
            }}
          >
            Deleted
          </Text>
        </Card>
      </CardSection>
    );
  }

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title={"Edit Announcement: " + title}
      >
        <form
          onSubmit={form.onSubmit((values) => {
            setLoad(true);
            editAnnouncement(values).then((values) => {
              setLoad(false);
              if (values != null) {
                setmessage(values.message);
                setpriority(values.important);
                settitle(values.title);
              }
            });
            setOpened(false);
          })}
        >
          <Text>Select Edit Fields</Text>
          <Chips multiple {...form.getInputProps("fields", { type: "chips" })}>
            <Chip value="title">Title</Chip>
            <Chip value="message">Content</Chip>
            <Chip value="important">Priority</Chip>
          </Chips>
          <Group mt="sm" style={{ display: "flex" }}>
            <TextInput
              label="Title"
              placeholder="Please Enter the title"
              style={{ width: "100%" }}
              {...form.getInputProps("title")}
            />
            <Textarea
              label="Content"
              placeholder="Please Enter the content of announcement"
              style={{ width: "100%" }}
              {...form.getInputProps("message")}
              width="100%"
            />
            <Checkbox
              label="Important"
              {...form.getInputProps("important", { type: "checkbox" })}
            />
          </Group>
          <Button fullWidth type="submit" mt="md">
            Submit
          </Button>
        </form>
      </Modal>
      <CardSection key={String(announcement.id)} style={{ marginBottom: 10 }}>
        <Card
          shadow="md"
          style={{
            backgroundColor:
              theme.colorScheme === "dark" ? theme.colors.dark[8] : "white",
          }}
        >
          <LoadingOverlay visible={isLoad} />
          <Text
            style={{
              fontSize: "20px",
              color: theme.colorScheme === "dark" ? "#3391FF" : "#0063F8",
              textAlign: "left",
            }}
          >
            <Tooltip
              label="This Star denotes Important Announcement"
              closeDelay={500}
            >
              <StarIcon
                color={"red"}
                style={{
                  float: "left",
                  display: priority ? "inline" : "none",
                }}
              />
            </Tooltip>
            {priority ? " " + title : title}
            <div style={{ float: "right" }}>
              <Button style={{ margin: 5 }} onClick={() => setOpened(true)}>
                <Pencil2Icon />
              </Button>
              <Button
                style={{ margin: 5, backgroundColor: "red" }}
                onClick={openDeleteModal}
              >
                <TrashIcon />
              </Button>
            </div>
          </Text>
          <Text style={{ textAlign: "left", color: "gray" }}>
            {moment(announcement.createdAt).fromNow()}
          </Text>
          <Space h="md" />
          <Text
            style={{
              fontSize: "18px",
              textAlign: "left",
            }}
          >
            {message}
          </Text>
          <Divider />
          <Space h="xs" />
          <Grid
            justify={isScreenLarge ? "space-between" : "space-around"}
            style={{ marginTop: 10 }}
          >
            <Badge
              color={"gray"}
              variant="light"
              style={{
                fontSize: isScreenLarge ? 14 : 10,
                margin: "2px 2px 2px 2px",
              }}
            >
              {domain}
            </Badge>
            <Badge
              color={"gray"}
              variant="light"
              style={{
                fontSize: isScreenLarge ? 14 : 10,
                margin: "2px 2px 2px 2px",
              }}
            >
              Posted by: {announcement.name}
            </Badge>
          </Grid>
        </Card>
      </CardSection>
    </>
  );
}
Announcement.propTypes = {
  announcement: PropTypes.any,
};

export const Announcements = () => {
  const isAdmin = localStorage.getItem("type") == "ADMIN" ? true : false;
  const [opened, setOpened] = useState(false);
  const [domains, setdomain] = useState([]);
  const [domainsLoad, setdomainLoad] = useState(true);
  const [announcements, setAnnouncements] = useState([]);
  const [load, setLoad] = useState(true);
  const [addLoad, setAddLoad] = useState(false);
  var theme = useMantineTheme();
  const isScreenLarge = useMediaQuery("(min-width: 500px)", false);
  const isMobile = useMediaQuery("(max-width: 600px)"); 
  const year=process.env.REACT_APP_CURRENT_YEAR;
  useEffect(() => {
    fetchDomains().then((res) => {
      setdomain(res);
      if (res.length != 0) setdomainLoad(false);
    });
  }, []);
  useEffect(() => {
    fetchAnnouncements().then((res) => {
      setAnnouncements(res);
      setLoad(false);
    });
  }, []);
  const form = useForm({
    initialValues: {
      title: "",
      message: "",
      important: false,
      domainId: "",
    },
  });
  if (isAdmin) {
    return (
      <>
        <Container
          style={{ width: "100%", paddingLeft: "0px", paddingRight: "0px" }}
        >
          <MediaQuery smallerThan="sm" styles={{ fontSize: 20 }}>
            <MediaQuery largerThan="sm" styles={{ fontSize: 40 }}>
              <Text
                weight={600}
                variant="gradient"
                gradient={{ from: "#0063F8", to: "#00FFF0", deg: 90 }}
                style={{
                  width: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textTransform: "uppercase",
                }}
              >
                {`Spider Inductions ${year}`}
              </Text>
            </MediaQuery>
          </MediaQuery>
          <Modal opened={opened} size="xl" onClose={() => setOpened(false)}>
            <LoadingOverlay visible={domainsLoad} />
            <form
              onSubmit={form.onSubmit((values) => {
                setAddLoad(true);
                if (values.domainId == "ALL") {
                  delete values.domainId;
                  newAllDomainsAnnouncement(values).then((newAnnouncements) => {
                    setAddLoad(false);
                    if (newAnnouncements != null) {
                      setAnnouncements((announcements) => [
                        newAnnouncements,
                        ...announcements,
                      ]);
                    }
                  });
                } else {
                  values.domainId = parseInt(values.domainId);
                  newAnnouncement(values).then((newAnnouncement) => {
                    setAddLoad(false);
                    if (newAnnouncement != null) {
                      setAnnouncements((announcements) => [
                        newAnnouncement,
                        ...announcements,
                      ]);
                    }
                  });
                }
                setOpened(false);
              })}
            >
              <Group mt="sm" style={{ display: "flex" }}>
                <TextInput
                  label="Title"
                  placeholder="Please Enter the title"
                  required
                  style={{ width: "100%" }}
                  {...form.getInputProps("title")}
                />
                <Textarea
                  label="Content"
                  placeholder="Please Enter the content of announcement"
                  required
                  style={{ width: "100%" }}
                  width="100%"
                  {...form.getInputProps("message")}
                />
                <Checkbox
                  label="Important"
                  {...form.getInputProps("important", { type: "checkbox" })}
                />
                <NativeSelect
                  label=" Select Domain"
                  placeholder="Pick one"
                  style={{ width: "100%" }}
                  data={[
                    { key: "ALL", value: "ALL", label: "ALL" },
                    ...domains.map((domainId) => {
                      return {
                        key: domainId.id,
                        value: domainId.id,
                        label: domainId.name,
                      };
                    }),
                  ]}
                  required
                  {...form.getInputProps("domainId")}
                />

                <Button type="submit">Submit</Button>
              </Group>
            </form>
          </Modal>
          <LoadingOverlay visible={addLoad} />
          <Container className="Text-style">
            <MediaQuery largerThan={920} styles={{ fontSize: 25, height: 30 }}>
              <Text
                style={{
                  width: "100%",
                }}
              >
                ANNOUNCEMENTS
              </Text>
            </MediaQuery>

            <MediaQuery largerThan={920} styles={{ fontSize: 18 }}>
              <Button
                onClick={() => setOpened(true)}
                sx={{
                  backgroundColor: "#EAF3FF", // Skyblue color
                  color: "#1C3D5A",
                  borderRadius: "8px",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  transition: "all 0.3s ease-in-out",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  padding: isMobile ? "8px" : "10px 20px",
                  width: isMobile ? "40px" : "auto",
                  height: isMobile ? "40px" : "auto",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Subtle shadow
                  cursor: "pointer", // Pointer cursor

                  "&:hover": {
                    backgroundColor: "#D6E9FF", // Lighter shade on hover
                    transform: "scale(1.05)", // Slight zoom effect
                    boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.15)", // Stronger shadow
                  },

                  "&:active": {
                    transform: "scale(0.98)", // Slight press-down effect when clicked
                  },
                }}
              >
                {isMobile ? (
                  <PlusIcon width={24} height={24} />
                ) : (
                  "Add Announcement"
                )}
              </Button>
            </MediaQuery>
          </Container>
          <Box
            sx={(theme) => ({
              backgroundColor:
                theme.colorScheme === "dark"
                  ? theme.colors.dark[5]
                  : theme.colors.gray[2],
              textAlign: "center",
              padding: theme.spacing.xl,
              cursor: "pointer",
              height: 570,

              "&:hover": {
                backgroundColor:
                  theme.colorScheme === "dark"
                    ? theme.colors.dark[4]
                    : theme.colors.gray[3],
              },
            })}
          >
            <ScrollArea style={{ height: 540 }} offsetScrollbars>
              <LoadingOverlay visible={load} />
              {[...announcements].map((announcement) => {
                return (
                  <Announcement
                    key={announcement.id}
                    announcement={announcement}
                  />
                );
              })}
            </ScrollArea>
          </Box>
        </Container>
      </>
    );
  } else {
    return (
      <>
        <Container style={{ width: "100%",paddingLeft: "0px",
        paddingRight: "0px", }}>
          <MediaQuery smallerThan="sm" styles={{ fontSize: 20 }}>
            <MediaQuery largerThan="sm" styles={{ fontSize: 40 }}>
              <Text
                weight={600}
                variant="gradient"
                gradient={{ from: "#0063F8", to: "#00FFF0", deg: 90 }}
                style={{
                  width: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textTransform: "uppercase",
                }}
              >
                {`Spider Inductions ${year}`}
              </Text>
            </MediaQuery>
          </MediaQuery>
          <Container className="Text-style">
            <MediaQuery largerThan={920} styles={{ fontSize: 30 }}>
              <Text>ANNOUNCEMENTS</Text>
            </MediaQuery>
          </Container>

          <Box
            sx={(theme) => ({
              backgroundColor:
                theme.colorScheme === "dark"
                  ? theme.colors.dark[5]
                  : theme.colors.gray[2],
              textAlign: "center",
              padding: theme.spacing.xl,
              cursor: "pointer",
              height: 570,

              "&:hover": {
                backgroundColor:
                  theme.colorScheme === "dark"
                    ? theme.colors.dark[4]
                    : theme.colors.gray[3],
              },
            })}
          >
            <ScrollArea style={{ height: 540 }} offsetScrollbars>
              <LoadingOverlay visible={load} />
              {[...announcements].map((announcement) => {
                return (
                  <CardSection
                    key={String(announcement.id)}
                    style={{ marginBottom: 10 }}
                  >
                    <Card
                      shadow="md"
                      style={{
                        backgroundColor:
                          theme.colorScheme === "dark"
                            ? theme.colors.dark[8]
                            : "white",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: "20px",
                          color:
                            theme.colorScheme === "dark"
                              ? "#3391FF"
                              : "#0063F8",
                          textAlign: "left",
                        }}
                      >
                        <Tooltip
                          label="This Star denotes Important Announcement"
                          closeDelay={500}
                        >
                          <StarIcon
                            color={"red"}
                            style={{
                              float: "left",
                              display: announcement.important
                                ? "inline"
                                : "none",
                            }}
                          />
                        </Tooltip>
                        {announcement.important
                          ? " " + announcement.title
                          : announcement.title}
                        <div style={{ float: "right" }}>
                          <Text
                            style={{
                              textAlign: "right",
                              color: "gray",
                              fontSize: "20px",
                            }}
                          >
                            {moment(announcement.createdAt).fromNow()}
                          </Text>
                        </div>
                      </Text>
                      <Space h="md" />
                      <Text
                        style={{
                          fontSize: "18px",
                          textAlign: "left",
                        }}
                      >
                        {announcement.message}
                      </Text>
                      <Divider />
                      <Space h="xs" />
                      <Grid
                        justify={
                          isScreenLarge ? "space-between" : "space-around"
                        }
                        style={{ marginTop: 10 }}
                      >
                        <Badge
                          color={"gray"}
                          variant="light"
                          style={{
                            fontSize: isScreenLarge ? 14 : 10,
                            margin: "2px 2px 2px 2px",
                          }}
                        >
                          {announcement.DomainName}
                        </Badge>
                        <Badge
                          color={"gray"}
                          variant="light"
                          style={{
                            fontSize: isScreenLarge ? 14 : 10,
                            margin: "2px 2px 2px 2px",
                          }}
                        >
                          Posted by: {announcement.name}
                        </Badge>
                      </Grid>
                    </Card>
                  </CardSection>
                );
              })}
            </ScrollArea>
          </Box>
        </Container>
      </>
    );
  }
};
